const UFbyDDD = {
  11: "SP",
  12: "SP",
  13: "SP",
  14: "SP",
  15: "SP",
  16: "SP",
  17: "SP",
  18: "SP",
  19: "SP",
  21: "RJ",
  22: "RJ",
  24: "RJ",
  27: "ES",
  28: "ES",
  31: "MG",
  32: "MG",
  33: "MG",
  34: "MG",
  35: "MG",
  37: "MG",
  38: "MG",
  41: "PR",
  42: "PR",
  43: "PR",
  44: "PR",
  45: "PR",
  46: "PR",
  47: "SC",
  48: "SC",
  49: "SC",
  51: "RS",
  53: "RS",
  54: "RS",
  55: "RS",
  61: "DF",
  62: "GO",
  63: "TO",
  64: "GO",
  65: "MT",
  66: "MT",
  67: "MS",
  68: "AC",
  69: "RO",
  71: "BA",
  73: "BA",
  74: "BA",
  75: "BA",
  77: "BA",
  79: "SE",
  81: "PE",
  82: "AL",
  83: "PB",
  84: "RN",
  85: "CE",
  86: "PI",
  87: "PE",
  88: "CE",
  89: "PI",
  91: "PA",
  92: "AM",
  93: "PA",
  94: "PA",
  95: "RR",
  96: "AP",
  97: "AM",
  98: "MA",
  99: "MA"
}

const UFlabelDDD = [
  {
    uf: 'DF',
    label: 'Distrito Federal',
    ddd: ['61'],
  },
  {
    uf: 'GO',
    label: 'Goiás',
    ddd: ['62', '64'],
  },
  {
    uf: 'MT',
    label: 'Mato Grosso',
    ddd: ['65', '66'],
  },
  {
    uf: 'MS',
    label: 'Mato Grosso do Sul',
    ddd: ['67'],
  },
  {
    uf: 'AL',
    label: 'Alagoas',
    ddd: ['82'],
  },
  {
    uf: 'BA',
    label: 'Bahia',
    ddd: ['71', '73', '74', '75', '77'],
  },
  {
    uf: 'CE',
    label: 'Ceará',
    ddd: ['85', '88'],
  },
  {
    uf: 'MA',
    label: 'Maranhão',
    ddd: ['98', '99'],
  },
  {
    uf: 'PB',
    label: 'Paraíba',
    ddd: ['83'],
  },
  {
    uf: 'PE',
    label: 'Pernambuco',
    ddd: ['81', '87'],
  },
  {
    uf: 'PI',
    label: 'Piauí',
    ddd: ['86', '89'],
  },
  {
    uf: 'RN',
    label: 'Rio Grande do Norte',
    ddd: ['84'],
  },
  {
    uf: 'SE',
    label: 'Sergipe',
    ddd: ['79'],
  },
  {
    uf: 'AC',
    label: 'Acre',
    ddd: ['68'],
  },
  {
    uf: 'AP',
    label: 'Amapá',
    ddd: ['96'],
  },
  {
    uf: 'AM',
    label: 'Amazonas',
    ddd: ['92', '97'],
  },
  {
    uf: 'PA',
    label: 'Pará',
    ddd: ['91', '93', '94'],
  },
  {
    uf: 'RO',
    label: 'Rondônia',
    ddd: ['69'],
  },
  {
    uf: 'RR',
    label: 'Roraima',
    ddd: ['95'],
  },
  {
    uf: 'TO',
    label: 'Tocantins',
    ddd: ['63'],
  },
  {
    uf: 'ES',
    label: 'Espírito Santo',
    ddd: ['27', '28'],
  },
  {
    uf: 'MG',
    label: 'Minas Gerais',
    ddd: ['31', '32', '33', '34', '35', '37', '38'],
  },
  {
    uf: 'RJ',
    label: 'Rio de Janeiro',
    ddd: ['21', '22', '24'],
  },
  {
    uf: 'SP',
    label: 'São Paulo',
    ddd: ['11', '12', '13', '14', '15', '16', '17', '18', '19'],
  },
  {
    uf: 'PR',
    label: 'Paraná',
    ddd: ['41', '42', '43', '44', '45', '46'],
  },
  {
    uf: 'RS',
    label: 'Rio Grande do Sul',
    ddd: ['51', '53', '54', '55'],
  },
  {
    uf: 'SC',
    label: 'Santa Catarina',
    ddd: ['47', '48', '49'],
  },
];

export {
  UFbyDDD,
  UFlabelDDD,
}
